import { Role } from '@/api/types'

export default [
    {
        path: '/',
        redirect: { name: 'dashboard' },
    }, {
        name: 'dashboard',
        path: '/dashboard',
        meta: {
            requiredRole: Role.EMPLOYEE,
            showScrollbar: false,
            noBackground: false,
            label: 'Dashboard',
            icon: {
                componentName: 'icon',
                type: 'dashboard',
            },
        },
        component: () => import(/* webpackChunkName: "dashboard" */ '../../views/Dashboard.vue'),
    },
]
